export function cssTimeToMilliseconds(timeString) {
  const num = parseFloat(timeString, 10);
  let unit = timeString.match(/m?s/);
  let milliseconds;

  if (unit) {
    unit = unit[0];
  }

  switch (unit) {
    case 's': // seconds
      milliseconds = num * 1000;
      break;
    case 'ms': // milliseconds
      milliseconds = num;
      break;
    default:
      milliseconds = 0;
      break;
  }

  return milliseconds;
}

export const transformToOrdinal = (i) => {
  const j = i % 10;
  const k = i % 100;
  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }
  return i + 'th';
};
